import React from 'react';
import HeaderOne from '../common/header/HeaderOne';
import Breadcrumb from '../common/breadcrumb/Breadcrumb';
import ServiceDetails from '../components/single-service/ServiceDetails';
import FooterOne from '../common/footer/FooterOne';
import { getServiceBySlug } from '../data/companyData';

const ServiceDetailPage = ({ slug }) => {
  const service = getServiceBySlug(slug);

  return (
    <>
      <HeaderOne />
      <Breadcrumb heading={service.title} currentPage={service.title} Img={service.image} />
      <ServiceDetails slug={slug} />
      <FooterOne />
    </>
  );
};

export default ServiceDetailPage;
